import { AxiosError } from "axios";
import taskManagerApi from "@/features/shared/services/taskManagerApi";
export const fetchRoles = async (params = {}) => {
    const queryParams = {
        ...params,
        all: params.all ?? true,
        ...(params.is_active !== undefined ? { is_active: String(params.is_active) } : {}),
    };
    const response = await taskManagerApi.get("/role", { params: queryParams });
    return response.data?.data?.roles ?? [];
};
export const createRole = async (payload) => {
    const response = await taskManagerApi.post("/role", payload);
    return response.data?.data?.role;
};
export const updateRole = async (id, payload) => {
    await taskManagerApi.put(`/role/${id}`, payload);
};
export const deleteRole = async (id) => {
    await taskManagerApi.delete(`/role/${id}`);
};
export const getRoleErrorMessage = (error) => {
    if (error instanceof AxiosError) {
        const apiMessage = error.response?.data?.error?.message ?? error.response?.data?.message;
        if (apiMessage) {
            return apiMessage;
        }
    }
    if (error instanceof Error) {
        return error.message;
    }
    return "Une erreur inattendue est survenue.";
};
